import React from 'react';
import './AboutUsSection.css';


import aboutImage from '../assets/images/about_us.png';

const AboutUsSection = () => {
  return (
    <section id="about" className="about-section">
      <h2>About Us</h2>
      <div className="about-content">
        <img src={aboutImage} alt="About Us" className="about-image" />
        <div className="about-info">
          <p>
            Welcome to DailyAppHub, where AI meets your daily needs in one smart package.
            We’re the product arm of byteeIT, developing a suite of AI-driven apps aimed
            at enhancing and simplifying your digital life. Step into the future with us
            as we offer seamless interfacing between tech and everyday life, delivering
            intelligent solutions that transform your world today and get you ready for a
            smarter tomorrow.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
